module.exports = __webpack_public_path__ + "static/cancel-icon-826aa0211b3ba96e4e2eca84fd979bb4.png";